import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function FormErrorMessage({ error, className }) {
    return error
        ? (_jsx("ul", { className: cn('text-danger-fg text-body-sm flex flex-col gap-stack-tight font-light', className), children: Array.isArray(error)
                ? error.map((msg, key) => (_jsxs("li", { children: [" ", msg, " "] }, key)))
                : _jsxs("li", { children: [" ", error, " "] }) }))
        : null;
}
